import Vue from 'vue';

export default {
    install(Vue, config) {
        Vue.prototype.config = function (key, defaultValue) {
            if (typeof config !== 'object' || typeof key !== 'string') {
                return defaultValue;
            }

            var value = config;
            var segments = key.split('.');

            for (var i in segments) {
                var segment = segments[i];

                if (typeof value === 'object' && value.hasOwnProperty(segment)) {
                    value = value[segment];
                } else {
                    return defaultValue;
                }
            }

            return value;
        }
    }
};
